/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { MarkersApi } from '@deckee/api-app-main';
import {
  event,
  imgElementSvg,
  mapEventMarkerWrapper,
} from '../../../components/shared/vector-images';

import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import apiConfiguration from '../../backend/apiConfiguration';
import {
  layerExists,
  setDataSource,
  sourceExists,
  toggleLayerIfRequired,
} from '../_helpers';
import { transitionToNextRoute } from '../../route/route-navigation';
import { ROUTE_MARKER_SUMMARY } from '../../route/route-names';
import { captureEvent } from '../../event-capture';

const markersApi = new MarkersApi(apiConfiguration);

let mapReference;
let selectedMarkerId = null;
const layerName = 'eventMarker';

const addLayersIfRequired = () => {
  if (!mapReference) return;

  if (!sourceExists(mapReference, layerName)) {
    mapReference.addSource(layerName, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [],
      },
    });
  }

  if (!layerExists(mapReference, layerName)) {
    mapReference.addLayer({
      id: layerName,
      type: 'symbol',
      source: layerName,
      layout: {
        'icon-image': 'eventMarker',
        'icon-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          0,
          ['case', ['==', ['get', 'markerSelected'], true], 0.5, 0.25],
          8.5,
          ['case', ['==', ['get', 'markerSelected'], true], 0.5, 0.25],
          11,
          ['case', ['==', ['get', 'markerSelected'], true], 0.5, 0.25],
          14,
          ['case', ['==', ['get', 'markerSelected'], true], 0.5, 0.4],
        ],
        'icon-anchor': 'bottom',
        'icon-allow-overlap': true,
        'text-allow-overlap': true,
      },
      paint: {},
    });
  }
};

const layer = {
  displayName: 'Event',
  synonyms: 'event',
  group: 'standardMarker',
  typeUrl: 'event',
  icon: {
    baseShape: event,
    iconColor: '#fff',
    markerColor: '#906BD9',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'general-services',
    order: 20,
  },
  standardMarkerOptions: {
    markerType: layerName,
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Event',
      itemTitleFunction: (item) => (item && item.title) || 'Event',
    },
    creationOptions: {
      menuText: 'Event',
      newTitle: 'Event',
      titlePlaceholder: 'Name of event',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker is used to indicate an event
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: false,
    title: 'Event',
    description: marker.title,
  }),
};

const loadMarkerImages = async (map) => {
  const marker = await imgElementSvg(
    mapEventMarkerWrapper(layer.icon.baseShape()),
    {
      fillColor: layer.icon.iconColor,
      markerColor: layer.icon.markerColor,
      width: 140,
      height: 140,
    },
  );
  marker.width = '140';
  marker.height = '140';

  if (!map.hasImage(layerName)) map.addImage(layerName, marker);
};

layer.onInitialize = async (map) => {
  mapReference = map;
  addLayersIfRequired();

  await loadMarkerImages(mapReference, layer);

  const { data } = await markersApi.getMarkers({ markerType: 'eventMarker' });

  const geojson = {
    type: 'FeatureCollection',
    features: data.map((item) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [item.latLon.lon, item.latLon.lat],
      },
      properties: {
        ...item,
        image: 'eventMarker',
        // This is so it doesn't deselect when reloading data
        markerSelected: selectedMarkerId === item.id,
      },
    })),
  };

  setDataSource(mapReference, layerName, geojson);

  map.on('deckee-press', layerName, async (clickEvent) => {
    // This is to select a marker and go to the popover
    const { id } = clickEvent.features[0].properties;
    if (!clickEvent.originalEvent.defaultPrevented) {
      // PrclickEvent the map click clickEvent from propagating to other layers
      clickEvent.originalEvent.preventDefault();

      selectedMarkerId = id;
      captureEvent({
        type: 'marker: click',
        payload: {
          markerType: 'eventMarker',
          id,
          clickedLatitude: clickEvent.lngLat.lat,
          clickedLongitude: clickEvent.lngLat.lng,
        },
      });
      transitionToNextRoute(ROUTE_MARKER_SUMMARY, {
        markerType: 'eventMarker',
        id,
      });
    }
  });
};

layer.onToggle = (map, show) => {
  toggleLayerIfRequired(map, layerName, show);
};

export default layer;
